import React from 'react';
// import { FormGroup, Input, FormFeedback, Label} from 'reactstrap'
import {connect} from 'react-redux'; 
import * as actions from "store/actions/colors"
import ImageInput from '../ImageInput';

class VerticalImageInput extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            name: "vertical",
            invalid: false
        }
        this.handleChange = this.handleChange.bind(this);
        this.verticalFileRef = React.createRef();
    }

    componentDidMount(){
   
    }

    handleChange(file){
        this.props.actions.change(this.state.name, file)
    }

    
    render(){
        return(
            <React.Fragment>
                <ImageInput
                    title={"Imagem vertical Mostruário"}
                    fileRef={this.verticalFileRef}
                    onChange={this.handleChange}
                    inputId={this.state.name}
                    url={this.props.image.url}>
                </ImageInput>
            </React.Fragment>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        image: state.colors.images.vertical,
        error: state.colors.errors.vertical
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions:{
            setError: (name, value) => {
                return dispatch({
                    type: actions.SET_ERROR,
                    payload: {
                        name: name,
                        value: value
                    }
                })
            },
            change: (name, value) => {
                return dispatch({
                    type: actions.SET_IMAGE,
                    payload: {
                        name: name,
                        value: value
                    }
                })
            }
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(VerticalImageInput);